<p-dialog header="Export Confirmation" [(visible)]="display" [style]="{width: '380px'}" [modal]="true" (onHide)="onDialogHide()">
    <div class="p-d-flex">
        <i class="pi pi-info-circle"></i>
        <span class="p-ml-2">Do you want to export this Report?</span>
    </div>
    <p-footer>
        <button type="button" pButton icon="pi pi-external-link" label="Open" (click)="export('open')"></button>
        <button type="button" pButton icon="pi pi-file-pdf" label="PDF" (click)="export('pdf')"></button>
        <button type="button" pButton icon="pi pi-file-excel" label="CSV" (click)="export('csv')"></button>
        <button type="button" pButton icon="pi pi-file-excel" label="XLSX" (click)="export('xlsx')"></button>
    </p-footer>
</p-dialog>
<app-finance-print-utility [selectedWindow]="selectedWindow" [selectedDateFilter]="selectedDateFilter"
 [cols]="cols" [profitReport]="profitReport" [dateFrom]="dateFrom"  [dateTo]="dateTo"></app-finance-print-utility>

